import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';

import {APIV2} from 'services/ApiServiceV2';

export const getAIChatHistory = createAsyncThunk(
  'chat/getAIChatHistory',
  async (arg, thunkAPI) => {
    return await APIV2(
      `v1/chat/history?page=${arg?.pageNo}&size=50`,
      'GET',
      {},
      'JAVA',
    )
      .then(res => {
        return {...res};
      })
      .catch(err => {
        return err;
      });
  },
);

export const postAiChat = createAsyncThunk(
  'chat/postAiChat',
  async (arg, thunkAPI) => {
    return await APIV2(`v1/chat`, 'POST', arg, 'JAVA')
      .then(res => {
        return {...res};
      })
      .catch(err => {
        return err;
      });
  },
);

export const aiChatGenerateImage = createAsyncThunk(
  'chat/aiChatGenerateImage',
  async (arg, thunkAPI) => {
    return await APIV2(`v1/chat/image`, 'POST', arg, 'JAVA')
      .then(res => {
        return {...res};
      })
      .catch(err => {
        return err;
      });
  },
);

export const imageUpload = createAsyncThunk(
  'chat/imageUpload',
  async (arg, thunkAPI) => {
    return await APIV2(`/admin/uploadAdminAsset`, 'POST', arg, 'NODE')
      .then(res => {
        return {...res};
      })
      .catch(err => {
        return err;
      });
  },
);

export const getSimilarProducts  = createAsyncThunk(
  'chat/getSimilarProducts',
  async (arg, thunkAPI) => {
    return await APIV2(`v1/chat/similar-products?productId=${arg?.productId}`, 'GET', arg, 'JAVA', undefined, {
      gender: arg?.gender,
    })
      .then(res => {
        return {...res};
      })
      .catch(err => {
        return err;
      });
  },
);

let initialState = {
  aiChatHistory: [],
  aiChatHistoryLoading: false,
};

export const chatSlice = createSlice({
  name: 'chat',
  initialState,
  reducers: {
    // changeParentSelected: (state, action) => {
    // },
  },
  extraReducers: builder => {
    builder
      .addCase(getAIChatHistory.pending, (state, action) => {
        state.aiChatHistoryLoading = true;
      })
      .addCase(getAIChatHistory.fulfilled, (state, action) => {
        state.aiChatHistory = action.payload;
        state.aiChatHistoryLoading = false;
      })
      .addCase(getAIChatHistory.rejected, (state, action) => {
        console.log('getAIChatHistory api error', action?.payload);
        state.aiChatHistoryLoading = false;
      });
  },
});

export const {} = chatSlice.actions;

export default chatSlice.reducer;
